module.exports = __webpack_public_path__ + "img/cp-ai-5.c72128c4.jpg";